/**
 * @desc 获取站点店铺信息和平台账号信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.PlatformSiteShopAndAppAccountResponseDto>
>;
export function request(
  body: defs.basics.PlatformSiteShopAndAppAccountQueryRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getPlatformShopAndAppAccount`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
